import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from "rxjs";

@Injectable()
export class TimesheetObsService {
    constructor() {}

    isDashboard: boolean;
    
    // Subjects
    refreshProjectSummaryDetails = new Subject<number>();
   
    openProjectTasksForACertainDay = new Subject<Date>();

    updateTeamTimesheetCount = new Subject<number>();

    refreshSummaryTabTimesheetList = new Subject<void>();

    setTimesheetIdFromNotifications = new Subject<number>();

    timesheetDetailOpenFromConsolidateView = new Subject<boolean>();
}
